<script setup lang="ts">
const currentYear = new Date().getFullYear();
</script>

<template>
    <div class="bg-cream-dark text-blurple-200 h-screen flex flex-col">
        <h1 class="flex flex-row justify-center px-4 pt-4">
            <router-link to="/login">
                <img class="max-w-[115px]" alt="Home" src="../assets/images/proper-labs-iso.svg" />
            </router-link>
        </h1>
        <div class="flex-expand p-4">
            <router-view></router-view>
        </div>
        <div class="px-4 pb-8 pt-4 text-center font-mono text-xs">PROPER AI {{ currentYear }}</div>
    </div>
</template>
